import { Layout, Row, Col, Button, Pagination, Checkbox, Form, Modal, Input, message, Alert, Select, Upload,Segmented, Radio } from 'antd';
import { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import AppHeader from '../components/Header';
import Filter from './Filter'; // Import the Filter component
import LeadsTable from './LeadsTable'; // Import the LeadsTable component
import CompanyTable from './CompanyTable'; // Import the CompanyTable component
import UploadData from '../components/UploadData'; // Import the UploadData component

import regionCountryOptions from '../data/regionCountryOptions.json'; // Import region-wise country options from JSON file
import { encryptData, decryptData } from '../middleware/encryption'; // Import encryption and decryption functions
import { DownloadOutlined, UploadOutlined,SearchOutlined,
  SaveOutlined, } from '@ant-design/icons';
import { formatCount } from './utils';
const { Content } = Layout;

const role_user = sessionStorage.getItem('role'); // Removed duplicate declaration

const dummySavedLeadsData = [
  {
    id: 1218,
    first_name: "John",
    last_name: "Kirk",
    title: "Director of Sales",
    company: "Grace Technologies",
    email: "jkirk@gracetechnologies.com",
    email_status: "Verified",
    seniority: "Director",
    departments: "Sales",
    corporate_phone: "+18003433421",
    country: "United States",
    city: "Chicago",
    state: "Illinois",
    company_address: "1515 East Kimberly Road, Davenport, Iowa, United States, 52807",
    company_country: "United States",
    industry: "machinery",
    num_employees: 82,
    linkedin_url: "http://www.linkedin.com/in/john-kirk-1a093727b",
    website: "http://www.graceport.com",
    company_linkedin_url: "http://www.linkedin.com/company/grace-technologies",
    facebook_url: "https://www.facebook.com/gracetechIA/",
    twitter_url: "https://twitter.com/GraceTechIA",
    annual_revenue: "6114000",
    created_at: "2025-03-19T19:28:01.496Z",
    updated_at: "2025-03-19T21:06:16.337Z",
    total_count: "86"
  }
];

const dummySavedCompanyData = [
  {
    id: 280,
    company_name: "Incsub",
    num_employees: 33,
    industry: "education management",
    website: "http://www.incsub.com",
    company_linkedin_url: "http://www.linkedin.com/company/incsub",
    twitter_url: "https://twitter.com/incsub",
    company_city: "Albert Park",
    company_state: "Victoria",
    company_country: "Australia",
    company_postal_code: "3206",
    company_address: "Albert Park, Victoria, Australia, 3206",
    keywords: "wordpress, blogs, communities, education, business, hosting",
    company_phone: "+61405703924",
    seo_description: "We are behind some of the largest and most trusted WordPress products...",
    technologies: "Route 53, MailJet, Gmail, Google Apps, MailChimp SPF, Microsoft Office 365...",
    annual_revenue: "11000000",
    founded_year: 2005,
    created_at: "2025-03-16T09:18:29.715Z",
    updated_at: "2025-03-16T09:18:29.715Z",
    total_count: "1003"
  }
];

const leadFields = [
  { label: 'Name', value: 'name' },
  { label: 'Title', value: 'title' },
  { label: 'Company', value: 'company' },
  { label: 'Email', value: 'email' },
  { label: 'Email Status', value: 'email_status' },
  { label: 'Seniority', value: 'seniority' },
  { label: 'Departments', value: 'departments' },
  { label: 'Phone', value: 'mobile_phone' },
  
  { label: 'Country', value: 'country' },
  { label: 'City', value: 'city' },
  { label: 'State', value: 'state' },
  { label: 'Industry', value: 'industry' },
  { label: 'Number of Employees', value: 'num_employees' },
  { label: 'Company Address', value: 'company_address' },
  { label: 'Website', value: 'website' },
  { label: 'Technologies', value: 'technologies' },
  { label: 'SEO Description', value: 'seo_description' },
];

const companyFields = [
  { label: 'Company Name', value: 'company_name' },
  { label: 'Number of Employees', value: 'num_employees' },
  { label: 'Industry', value: 'industry' },
  { label: 'Website', value: 'website' },
  { label: 'Company City', value: 'company_city' },
  { label: 'Company State', value: 'company_state' },
  {label:'Company Phone',value:'company_phone'},
  { label: 'Company Country', value: 'company_country' },
  { label: 'Company Address', value: 'company_address' },
  { label: 'Technologies', value: 'technologies' },
  { label: 'SEO Description', value: 'seo_description' },
];

const defaultLeadFields = ['name', 'title', 'email', 'mobile_phone', 'country','company', 'industry','num_employees','website','email_status','seniority','departments','city','state','company_address','technologies','seo_description'];
const defaultCompanyFields = ['company_name', 'num_employees', 'industry', 'company_phone','website','company_city','company_state','company_country','company_address','technologies','seo_description'];
const role= sessionStorage.getItem('role');
export default function Leads() {
  const [collapsed, setCollapsed] = useState(false);
  const [form] = Form.useForm();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [leadsData, setLeadsData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [childOptions, setChildOptions] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedTechnologies, setSelectedTechnologies] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filters, setFilters] = useState({});
  const [exportLoading, setExportLoading] = useState(false);
  const [selectedFields, setSelectedFields] = useState(activeTab === '1' ? defaultLeadFields : defaultCompanyFields);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [perCompany, setPerCompany] = useState(false);
  const [perCompanyValue, setPerCompanyValue] = useState(null);
  const [planData, setPlanData] = useState();
  const [view, setView] = useState('Finder');
  const [lastPageForView, setLastPageForView] = useState({ Finder: 1, Saved: 1 });
  const [statusOfLeads, setStatusOfLeads] = useState(null);
  const [savedModalOpened, setSavedModalOpened] = useState(false);
  const [isSavedLeadsModalVisible, setIsSavedLeadsModalVisible] = useState(false);
  const [includeEmail, setIncludeEmail] = useState(true);
  const [includeMobile, setIncludeMobile] = useState(true);
  const [isSelectAllModalVisible, setIsSelectAllModalVisible] = useState(false);
  const [rowSelection, setRowSelection] = useState(0);
  const [perCompanyContact, setPerCompanyContact] = useState(0);
  const [perCompanyStatus, setPerCompanyStatus] = useState(false);
  const [exportType, setExportType] = useState('selected');
  const [leadCount, setLeadCount] = useState(0);
  const [savedLeadsData, setSavedLeadsData] = useState([]);
  const [savedLeadsLoading, setSavedLeadsLoading] = useState(false);
  const [deleteLeadsButtonLoading, setDeleteLeadsButtonLoading] = useState(false);  
  const [allSelectOptionAllowed, setAllSelectOptionAllowed] = useState(false);
  const [SelectLeadloading, setSelectLeadLoading] = useState(false);

  const [freeUserType,setFreeUserType]=useState(false);


  

  useEffect(() => { 
    if (view === "Finder") {
        fetchData(filters, page, limit);
        fetchUserCredits();
    }
    // ... saved, etc, as you already do
}, [filters, page, limit, view]);



  const fetchData = (filters = {}, page = 1, currentLimit = limit) => { // Add currentLimit parameter
  setLoading(true);
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const token = sessionStorage.getItem('access_token');
  if (token) {
    myHeaders.append("Authorization", `Bearer ${token}`);
  }

  console.log(currentLimit);
  console.log({
    ...filters,
    page,
    limit: currentLimit, // Use the passed currentLimit
    sort_by: "first_name",
    sort_order: "asc"
  });

  const encryptedData = encryptData({
    ...filters,
    page,
    limit: currentLimit, // Use the passed currentLimit
    sort_by: "first_name",
    sort_order: "asc",
    view: view === 'Finder' ? 'finder' : 'saved'
    
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({ data: encryptedData }),
    redirect: "follow"
  };

  const endpoint = activeTab == '1' ? "https://api.app.exellius.com/api/leads/getPeopleLeads/" : "https://api.app.exellius.com/api/leads/getCompanies/";



  fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      

      if (result.data) {
        const decryptedResponse = decryptData(result.data);

        console.log(decryptedResponse);

        if (activeTab === '1') {
          setLeadsData(decryptedResponse.data.map(item => ({ ...item, full_name: `${item.first_name} ${item.last_name}` })));
        } else {
          setCompanyData(decryptedResponse.data);
        }

        if (Object.keys(filters).length == 0) {
          setAllSelectOptionAllowed(false);
        } else {
          setAllSelectOptionAllowed(true);
        }
        setTotal(decryptedResponse.total_count);
        // You might want to remove this if you are always setting limit via onShowSizeChange
        // if (decryptedResponse.per_page_count == 20) {
        //   setLimit(decryptedResponse.per_page_count);
        // }
      } else {
        if (activeTab === '1') {
          setLeadsData([]);
        } else {
          setCompanyData([]);
        }
        setTotal(0);
      }
      setLoading(false);
    })
    .catch((error) => {
      console.error(error);
      setLoading(false);
    });
};
  const handleFilter = (values) => {
    
    setFilters(values);
    setPage(1);
    fetchData(values,1);
  };

  const setActiveTabFinal = (key) => {
    setView("Finder");
    setActiveTab(key);
    setPage(1); 
    setFilters({});
    setPerCompanyStatus(false)
    setSelectedFields((key == '1' ? defaultLeadFields : defaultCompanyFields));   
    setSelectedKeys([]);
    
  };

  const handleReset = () => {
    form.resetFields();
    setSelectedDepartments([]);
    setSelectedKeywords([]);
    setSelectedParent(null);
    setChildOptions([]);
    setSelectedTechnologies([]);
    setSelectedCountries([]);
    setFilters({});
    fetchData();

  };

  const handleDepartmentChange = (selectedChildren) => {
    setSelectedDepartments(selectedChildren);
  };

  const handleSelect = (id) => {

  
    setSelectedKeys((prevSelectedKeys) => {
      if (prevSelectedKeys.includes(id)) {
        return prevSelectedKeys.filter((selectedKey) => selectedKey !== id);
      } else {
        return [...prevSelectedKeys, id];
      }
    });
  };

  const handleSelectAll = () => {


    if(selectedKeys.length === 0) {
    setIsSelectAllModalVisible(true);
    }else{

      setSelectedKeys([]);
    }
  };

  const handleSelectAllOk = async () => {
  try {
    setSelectLeadLoading(true);
    const myHeaders = new Headers();
    const token = sessionStorage.getItem('access_token');
          if (token) {
            myHeaders.append("Authorization", `Bearer ${token}`);
          }

    const raw = {
      type: activeTab === '1' ? 'people' : 'company',
      filters,
      rowSelection,
      percomponyContact: perCompanyContact,
      isSaved : view === 'Saved' ? true : false,

    };

   
    console.log(raw);
    const requestOptions = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ data: encryptData(raw)}),
      redirect: "follow"
    };

   
    
    const response = await fetch("https://api.app.exellius.com/api/leads/getselectedLeads/", requestOptions);
    const result = await response.json();
    

    console.log(result);
    if (response.ok) {



      const selectedKeys=decryptData(result.data);

      console.log(selectedKeys);
      setSelectedKeys(selectedKeys.leadIds);

      
      message.success("Leads selected successfully");
    } else {
      message.error(result.message || "Failed to select leads");
    }
  } catch (error) {
    console.error("Error selecting leads:", error);
    message.error("An error occurred while selecting leads");
  } finally {
    setSelectLeadLoading(false);
    setIsSelectAllModalVisible(false);
  }
};

  const handleSelectAllCancel = () => {

    
    setIsSelectAllModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form.validateFields().then(values => {
      setExportLoading(true);



     

      const exportLimit = values.limit;
      const endpoint = activeTab === '1' ? 'https://api.app.exellius.com/api/leads/exportPeopleLeadsToCSV' : 'https://api.app.exellius.com/api/leads/exportCompaniesToCSV';
      const token = sessionStorage.getItem('access_token');


     
      
     
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
       body: JSON.stringify(
  exportType === 'selected'
    ? 
     { ...filters, leadsId: selectedKeys,includeEmail:includeEmail, includeMobile: includeMobile, role: role }
      
    : {
        ...filters,
        limit: leadCount,
        role: role,
        getSelected: false,
        includeEmail:includeEmail, 
        includeMobile: includeMobile
      }
)
      };

      

   
    

      fetch(endpoint, requestOptions)
  .then(response => {
    if (!response.ok) {
      // If response is not OK, throw an error to be caught in the catch block
      throw new Error("In-Sufficinent credit in your account");
    }
    return response.blob(); // Proceed to blob only if response is OK
  })
  .then(blob => {
    // Create a Blob URL with the appropriate MIME type
    const url = window.URL.createObjectURL(new Blob([blob], { type: 'text/csv;charset=utf-8;' }));
    console.log(url);  // Log the Blob URL (for debugging)

    // Create a download link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'exported-data.csv');  // Set the file name
    document.body.appendChild(link);
    link.click();  // Trigger the download
    document.body.removeChild(link);  // Clean up the link element

    // Handle UI state updates after download
    setIsModalVisible(false);
    setExportLoading(false);
  })
  .catch(error => {
    console.error('Export failed:', error.message);
    message.error('Export failed: ' + error.message);
    setExportLoading(false);  // Ensure loading state is reset on error
  });

      
       
    }).catch(info => {
      console.log('Validate Failed:', info);
      setExportLoading(false);
    });
    
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handlePaginationChange = (page) => {
    setPage(page);
    setLastPageForView(prev => ({ ...prev, [view]: page }));
    
    if (view == 'Saved') {
      handleSegmentChange('Saved', page);
    } else {
      fetchData(filters, page);
    }
  };

  const handleSegmentChange = (segment, page = null) => {

    setSelectedKeys([]);
    console.log(segment);
    setPerCompanyStatus(false);
    const targetPage = page !== null ? page : lastPageForView[segment] || 1;
    setPage(targetPage);
    if (segment == 'Saved') {

      console.log("fetch saved");
      
      fetchSavedLeads(segment,targetPage);
    } else {
      fetchData(filters, targetPage);
    }
    setView(segment);
  };

  const handleFieldChange = (selectedFields) => {
    const defaultFields = activeTab === '1' ? defaultLeadFields : defaultCompanyFields;
    setSelectedFields([...new Set([...defaultFields, ...selectedFields])]);
  };

  const showUploadModal = () => {
    setIsUploadModalVisible(true);
  };

  const handleUploadCancel = () => {
    setIsUploadModalVisible(false);
    setFileList([]);
  };

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
  };

  const fetchUserCredits = async () => {
        try {
          const myHeaders = new Headers();
          const token = sessionStorage.getItem('access_token');
          if (token) {
            myHeaders.append("Authorization", `Bearer ${token}`);
          }

          
  
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
          };
  
          const response = await fetch("https://api.app.exellius.com/api/users/getUserPoints", requestOptions);
          const result = await response.json();
          if (result.data) {
            const decryptedResponse = decryptData(result.data);
            console.log(decryptedResponse);
            setFreeUserType(decryptedResponse.freeUser)
            setPlanData(decryptedResponse.points);
          } else {
            message.error(result.message || "Failed to fetch user credits");
          }
        } catch (error) {
          console.error('Error fetching user credits:', error);
          message.error("An error occurred while fetching user credits");
        }
      };

      const fetchSavedLeads = (value,page) => {
        setView(value);
        setLoading(true);
        if (value === 'Finder') {
          fetchData(); 
        } else {
          setStatusOfLeads("save");
          const token = sessionStorage.getItem('access_token');
          const myHeaders = new Headers();

          console.log(token);
          myHeaders.append(
            "Authorization",
            `Bearer ${token}`
          );
      
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
      

          
          if (activeTab === '1') {
            // Fetch and update leads data
            fetch("https://api.app.exellius.com/api/leads/getSavedLeads?type=leads&page="+page+"&limit="+limit, requestOptions)
              .then((response) => response.json())
              .then((data) => {
                const decryptedResponse = decryptData(data.data);

                console.log(decryptedResponse)

                
                setLeadsData([...decryptedResponse.data]); // Assuming data is in the format you need
                setTotal(decryptedResponse.pagination.total);
    
                
                setLoading(false);
              })
              .catch((error) => {
                console.error('Error fetching saved leads:', error);
                setLoading(false);
              });
          } else {
            // Fetch and update company data
            fetch("https://api.app.exellius.com/api/leads/getSavedLeads?type=company&page="+page+"&limit="+limit, requestOptions)
              .then((response) => response.json())
              .then((data) => {
               const decryptedResponse = decryptData(data.data);

               console.log(decryptedResponse);
                 setCompanyData([...decryptedResponse.data]); // Assuming data is in the format you need
                setTotal(decryptedResponse.pagination.total);
    
               
                setLoading(false);
              })
              .catch((error) => {
                console.error('Error fetching saved companies:', error);
                setLoading(false);
              });
          }
        }
      };
      

      const DeleteLeadsFromSave =async () => {

       

        try {


          setDeleteLeadsButtonLoading(true);
          // Get the token from session storage
          const token = sessionStorage.getItem('access_token');
          const myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');
          console.log(token);
          if (token) {
            myHeaders.append('Authorization', `Bearer ${token}`);
          }
      
          // Dynamically construct the leadsArray based on user selection
          const leadsArray = selectedKeys.map((leadId) => ({
            leadId,
            email: includeEmail,
            mobile: includeMobile,
            type: activeTab === '1' ? 'leads' : 'company',
          }));
      
          // Prepare the payload to match the backend request
          const payload = {
            leads: leadsArray,
            type: activeTab === '1' ? 'leads' : 'company',
          };
      
          
      
          // Encrypt the payload
          const encryptedData = encryptData(payload);
         
      
          // Prepare the request body with the encrypted data
          const requestBody = {
            data: encryptedData, // Backend expects the encrypted data wrapped in an object
          };
      
          // Send the POST request using fetch
          const response = await fetch('https://api.app.exellius.com/api/leads/unsaveLeads', {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(requestBody), // Convert the object to JSON string
            redirect: 'follow',
          });
      
          // Parse the JSON response and decrypt the data
          const result = await response.json();
          const decryptedResponse = decryptData(result.data);
          console.log('Decrypted Response:', decryptedResponse);
      
          // Handle response based on status
          setDeleteLeadsButtonLoading(false);
          if (response.ok) {
            console.log('Leads saved successfully');
            message.success('Leads delete successfully');
            handleSegmentChange('Saved', 1);
            
          } else {
            console.error('Failed to save leads:', result.message);
            message.error(result.message || 'Failed to Delete leads');
          }
        } catch (error) {
          console.error('Error saving leads:', error);
          message.error('An error occurred while saving leads');
        } finally {
          setIsSavedLeadsModalVisible(false);
        }

      }

      const handleSavedLeadsOk = async () => {
  try {


    setSavedLeadsLoading(true);
    // Get the token from session storage
    const token = sessionStorage.getItem('access_token');
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    console.log(token);
    if (token) {
      myHeaders.append('Authorization', `Bearer ${token}`);
    }

    // Dynamically construct the leadsArray based on user selection
    const leadsArray = selectedKeys.map((leadId) => ({
      leadId,
      email: includeEmail,
      mobile: includeMobile,
      type: activeTab === '1' ? 'leads' : 'company',
    }));

    // Prepare the payload to match the backend request
    const payload = {
      leads: leadsArray,
      type: activeTab === '1' ? 'leads' : 'company',
    };

    

    // Encrypt the payload
    const encryptedData = encryptData(payload);
   

    // Prepare the request body with the encrypted data
    const requestBody = {
      data: encryptedData, // Backend expects the encrypted data wrapped in an object
    };

    // Send the POST request using fetch
    const response = await fetch('https://api.app.exellius.com/api/leads/saveLeads', {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(requestBody), // Convert the object to JSON string
      redirect: 'follow',
    });

    // Parse the JSON response and decrypt the data
    const result = await response.json();
    const decryptedResponse = decryptData(result.data);
    console.log('Decrypted Response:', decryptedResponse);
setSavedLeadsLoading(false);
    // Handle response based on status
    if (response.ok) {
      console.log('Leads saved successfully');
      message.success('Leads saved successfully');
      setSavedModalOpened(false);
    } else {
      console.error('Failed to save leads:', result.message);
      message.error(result.message || 'Failed to save leads');
    }
  } catch (error) {
    console.error('Error saving leads:', error);
    message.error('An error occurred while saving leads');
  } finally {
    setIsSavedLeadsModalVisible(false);
  }
};


    
      const handleSavedLeadsCancel = () => {
        setSavedModalOpened(false);
      };

      const handleAdminDelete = async () => {
  if (selectedKeys.length === 0) {
    message.warning("Please select leads or companies to delete.");
    return;
  }

  // Confirm before deleting
  Modal.confirm({
    title: "Are you sure?",
    content: "This will permanently delete the selected records. This action cannot be undone.",
    okText: "Delete",
    okType: "default",
    cancelText: "Cancel",
    onOk: async () => {
      try {
        // Use the actual token from session storage
        const token = sessionStorage.getItem('access_token');
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        if (token) {
          myHeaders.append("Authorization", `Bearer ${token}`);
        }

        const raw = JSON.stringify({
          ids: selectedKeys,
        });

        // Correct endpoint based on active tab
        const url =
          activeTab === '1'
            ? "https://api.app.exellius.com/api/leads/deletePeopleLeads"
            : "https://api.app.exellius.com/api/leads/deleteCompanies";

        const requestOptions = {
          method: "DELETE",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        const response = await fetch(url, requestOptions);
        if (response.ok) {
          message.success("Deleted successfully.");
          // Refresh data after deletion
          setSelectedKeys([]);
          fetchData(filters, page, limit);
        } else {
          const error = await response.text();
          message.error(error || "Delete failed");
        }
      } catch (error) {
        console.error(error);
        message.error("An error occurred while deleting");
      }
    }
  });
};


  return (
    <Layout style={{ minHeight: '125vh',overflow:"scroll" }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout className="site-layout">
        <AppHeader planData={planData} />
        <Content style={{ margin: '0 16px', height: 'calc(125vh - 64px)' }}>
          <div style={{ background: '#fff', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', borderRadius: 10, height: "calc(100% - 34px)", display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: 10, borderBottom: '1px solid #f0f0f0' }}>
              <div>
                <Button type="default" style={{ fontWeight: 600,color:"black !important",height:"100%" }}>{formatCount(total)} {activeTab === '1' ? 'Records' : 'Records'}</Button>
                <Button type="default" style={{ fontWeight: 600,color:"black !important",height:"100%",border:"none" }}>{formatCount(selectedKeys.length)} {activeTab === '1' ? 'Leads selected' : 'Companies selected'} </Button>
              </div>

            

      {/* Center Section: Segmented Picker for Finder & Saved Leads */}
      <div>
        <Segmented
  className="custom-segmented"
  value={view}
  onChange={handleSegmentChange}
  options={[
    {
      label: (
        <div className="segment-item">
          <SearchOutlined />
          <span>Finder</span>
        </div>
      ),
      value: 'Finder',
    },
    {
      label: (
        <div className="segment-item">
          <SaveOutlined />
          <span>Saved</span>
        </div>
      ),
      value: 'Saved',
    },
  ]}
/>
      </div>

     
              
              <div>



                
              <Select
              style={{marginRight: 10,width:300}}
                  mode="multiple"
                  placeholder="Select fields to display"
                  maxTagCount="responsive"
                  showSearch
                  
                  onChange={handleFieldChange}
                  value={selectedFields}
                  options={activeTab === '1' ? leadFields : companyFields}
                />

      {view=="Finder"?<>
             

<Button 
  
  style={{ marginLeft: 10, height: "100%" }} 
  onClick={() => {
    if (selectedKeys.length === 0) {
      message.warning('Please select leads'); // Show warning if no leads are selected
    } else {
      setSavedModalOpened(true); // Open modal only if leads are selected
    }
  }}

  className='custom-hover-style'
>
  Save
</Button>

{role_user === "admin" && (
  <Button
   
    type="default"
    style={{ marginLeft: 10, height: "100%" }}
    onClick={handleAdminDelete}
    loading={deleteLeadsButtonLoading} // Optional if you want to set a loading spinner
  >
    Delete
  </Button>
)}

</>:
<>
<Button 
  type='default' 
  style={{ marginLeft: 10, height: "100%" }} 
  onClick={() => {
    if (selectedKeys.length === 0) {
      message.warning('Please select leads'); // Show warning if no leads are selected
    } else {
      DeleteLeadsFromSave(true); // Open modal only if leads are selected
    }
  }}
  loading={deleteLeadsButtonLoading} // Add loading state
>
  Delete
</Button>
</>

}

                <Button style={{marginLeft:10,height:"100%"}} type="default" icon={<DownloadOutlined />} onClick={showModal}>Export</Button>
                
              </div>
            </div>
            <Row gutter={0} style={{ marginBottom: 16, flex: 1, overflow: 'hidden' }}>
              <Col span={6}>
                <div id="filter-component" style={{ borderRight: '1px solid #f0f0f0', overflowY: 'auto', position: 'relative', height: '100%' }}>
                  <Filter
                    form={form}
                    handleFilter={handleFilter}
                    handleReset={handleReset}
                    handleDepartmentChange={handleDepartmentChange}
                    selectedParent={selectedParent}
                    selectedTechnologies={selectedTechnologies}
                    childOptions={childOptions}
                    setLeadsData={setLeadsData}
                    setCompanyData={setCompanyData}
                    setActiveTabMain={setActiveTabFinal}
                    statusOfLeads={statusOfLeads}
                  />
                </div>
              </Col>
              <Col span={18} style={{ overflow: 'auto' }}>
                <div style={{ height: 'calc(125vh - 240px)' }}>
                  {activeTab === '1' ? (
                    <LeadsTable
                      data={leadsData}
                      selectedKeys={selectedKeys}
                      handleSelect={handleSelect}
                      handleSelectAll={handleSelectAll}
                      loading={loading}
                      selectedFields={selectedFields}
                      fetchData={fetchData}
                      getRemainingCredit={fetchUserCredits}
                      allSelectOptionAllowed={allSelectOptionAllowed||view=="Saved"}

                    />
                  ) : (
                    <CompanyTable
                      data={companyData}
                      selectedKeys={selectedKeys}
                      handleSelect={handleSelect}
                      handleSelectAll={handleSelectAll}
                      loading={loading}
                      selectedFields={selectedFields}
                      fetchData={fetchData}
                      getRemainingCredit={fetchUserCredits}
                      allSelectOptionAllowed={allSelectOptionAllowed||view=="Saved"}

                    />
                  )}
                </div>

                <div style={{  borderTop: '1px solid #f0f0f0', textAlign: 'center',paddingTop:10 }}>
                 
                 <Pagination
  showSizeChanger
  pageSizeOptions={['20', '50', '99']}
  onShowSizeChange={(current, size) => {
    setLimit(size);
    setPage(1); // Reset to first page
  }}
  total={total}
  pageSize={limit}
  current={page}
  onChange={(newPage) => {
    const maxPages = (view === 'Saved' || role === 'admin' )? Infinity : (freeUserType ? 5 : 50);
    if (newPage <= maxPages) {
      handlePaginationChange(newPage);
    } else {
      message.warning('Upgrade to a paid plan to access more pages.');
    }
  }}
  style={{ color: '#1890ff' }}
/>

                </div>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
      <Modal
  title="Export Leads"
  visible={isModalVisible}
  onOk={handleOk}
  okText="Export in CSV"
  onCancel={handleCancel}
  confirmLoading={exportLoading}
  okButtonProps={{ disabled: exportType === 'selected' && selectedKeys.length === 0 }} // Disable button
>
  <Form layout="vertical">
    <Form.Item>
      <Radio.Group onChange={(e) => setExportType(e.target.value)} value={exportType}>
        <Radio value="selected">Selected Contacts</Radio>
        <Radio value="all">All Contacts</Radio>
      </Radio.Group>
    </Form.Item>

   <div className="custom-checkbox-group">
  {activeTab === '1' && (
    <label className="custom-checkbox-wrapper">
      <Checkbox checked={includeEmail} onChange={(e) => setIncludeEmail(e.target.checked)} />
      <span className="custom-icon" />
      Include Email
    </label>
  )}

  <label className="custom-checkbox-wrapper">
    <Checkbox checked={includeMobile} onChange={(e) => setIncludeMobile(e.target.checked)} />
    <span className="custom-icon" />
    Include Mobile
  </label>
</div>

    {exportType === 'all' && (
      <Form.Item style={{ marginTop: 20 }} label="Number of Leads">
  <Input
    type="number"
    value={leadCount}
    onChange={(e) => {
      let value = Number(e.target.value);

      if (value > total) { // Replace totalCount with your total leads variable
        value = total;
        message.warning(`Maximum allowed is ${total}.`);
      }

      setLeadCount(value);
    }}
  />
</Form.Item>
    )}
  </Form>

 <Alert
  message="Note: For exports exceeding 1000 leads, the file will be emailed to you."
  type="info"
  showIcon
  icon={<img src="/explain.png" alt="info" style={{ width: 24, height: 24,marginRight:20 }} />}
  style={{ 
    marginBottom: 15, 
    marginTop: 20, 
    backgroundColor: '#FFF5FD',
    border: "none"
  }}
/>
</Modal>

     
     
      <Modal
  title="Save Leads"
  visible={savedModalOpened}
  onOk={handleSavedLeadsOk}
  onCancel={handleSavedLeadsCancel}
  okText="Save"
  confirmLoading={savedLeadsLoading} // Added loading state
>
  {activeTab == 1 && (
    <Checkbox checked={includeEmail} onChange={(e) => setIncludeEmail(e.target.checked)}>
      Include Email
    </Checkbox>
  )}
  <Checkbox checked={includeMobile} onChange={(e) => setIncludeMobile(e.target.checked)}>
    Include Mobile
  </Checkbox>
</Modal>

     <Modal
  title="Select All Leads"
  visible={isSelectAllModalVisible}
  onOk={handleSelectAllOk}
  onCancel={handleSelectAllCancel}
  okText="Select"
  confirmLoading={SelectLeadloading}
>
  <Form layout="vertical">
    <Form.Item>
      <Radio.Group
        onChange={(e) => {
          const value = e.target.value;
          setPerCompanyStatus(value);
          if (value === false) {
            setPerCompanyContact(0);
          }
        }}
        value={perCompanyStatus}
      >
        <Radio disabled={activeTab === 2 || view === "Saved"} value={true}>
          Contacts per Company
        </Radio>
        <Radio value={false}>Select Contacts</Radio>
      </Radio.Group>
    </Form.Item>

    {perCompanyStatus ? (
      <>
        <Form.Item label="Select number of people">
          <Input
            type="number"
            value={rowSelection}
            onChange={(e) => {
              let value = Number(e.target.value);

              if (value > 10000) { // replace total with your total lead count variable
                value = 10000;
                message.warning(`Maximum allowed is 10000.`);
              }

              setRowSelection(value);
            }}
          />
        </Form.Item>

        <Form.Item label="Max people per company">
          <Input
            type="number"
            value={perCompanyContact}
            onChange={(e) => {
              let value = Number(e.target.value);

              if (value > 10000) { 
                
                value = 10000;
                message.warning(`Maximum allowed is 10000.`);
              }else if(value>total){
                value=total;
                message.warning(`Maximum allowed is ${total}.`);
              }

              setPerCompanyContact(value);
            }}
          />
        </Form.Item>
      </>
    ) : (
      <Form.Item label="Contact Count">
        <Input
          type="number"
          value={rowSelection}
          onChange={(e) => {
            let value = Number(e.target.value);

            if (value > 10000) { // replace total with your total lead count variable
              value = 10000;
              message.warning(`Maximum allowed is 10000.`);
            } else if (value > total) {
              value = total;
              message.warning(`Maximum allowed is ${total}.`);
            }

            setRowSelection(value);
          }}
        />
      </Form.Item>
    )}
  </Form>
</Modal>
    </Layout>
  );
}
